// extracted by mini-css-extract-plugin
module.exports = {"main":"list_main__zCJtr","ask":"list_ask__LNXO5","bid":"list_bid__ca2Bs","atv":"list_atv__x1M_Z"};